import DatalignChip from "./DatalignChip";

export default DatalignChip;
